import { ref, onMounted, onUpdated } from "vue"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import { MESSAGES } from "@/messages"
import RatingTypeSearch from "../enums/RatingTypeSearch"
import router from "../router"

export function useRatingSkills() {
  const rankList = ref([])
  const validationList = ref([])
  const isLowerThanMobile = ref(typeof window !== 'undefined' ? window.innerWidth < 300 : false)
  const isMobile = ref(typeof window !== 'undefined' ? window.innerWidth < 600  && window.innerWidth > 300 : false)
  const rankType = ref(RatingTypeSearch.ALL)
  const selectedDDL = ref(null)
  const filterByJob = ref(true)
  const fetchingRankList = ref(false)

  const tooltipKnowledge = ref({
    1: "Conheço de forma limitada", 2: "Conheço menos bem", 3: "Compreendo razoavelmente", 4: "Compreendo bem", 5: "Integro muito bem", 6: "Integro na perfeição"
  })

  const tooltipSkillOp = ref({
    1: "Uso de forma limitada", 2: "Uso menos bem", 3: "Aplico razoavelmente", 4: "Aplico bem", 5: "Transformo muito bem", 6: "Transformo na perfeição"
  })

  async function GetRatingSkills(filterInput = "") {
    fetchingRankList.value = true
    const keepOpen = rankList.value.filter(elem => elem.showDetail == true)

    const res = await KNOLIA.CallBackEnd("get", "get-rating-skills", {
      params: {
        filter: filterInput,
        rankType: rankType.value,
        ddlSelected: selectedDDL.value,
        filterByJob: filterByJob.value,
      },
    })

    if(res.data.rank_list) {
      res.data.rank_list.forEach(elem => {
        if(keepOpen.some(keep => keep.skill_elem_id === elem.skill_elem_id && keep.is_op_skill === elem.is_op_skill)) {
          elem.showDetail = true
        }
      })
    }

    fetchingRankList.value = false
    rankList.value = res.data.rank_list
    validationList.value = res.data.validation_list
    if(res.data.rank_list.length === 0 && rankType.value == RatingTypeSearch.RANKED) {
      rankType.value = RatingTypeSearch.ALL
      GetRatingSkills()
    }
  }

  async function GetRatingSkill(newSkillsRatingsId) {

    const res = await KNOLIA.CallBackEnd("get", "get-rating-skills", {
      params: {
        filter: "",
        rankType: rankType.value,
        ddlSelected: selectedDDL.value,
        filterByJob: filterByJob.value,
        newSkillsRatingsId
      },
    })

    if(res.data.rank_list) {
      res.data.rank_list.forEach(elem => {
        rankList.value.forEach(oldElem => {
          if(oldElem.skill_elem_id === elem.skill_elem_id && oldElem.is_op_skill === elem.is_op_skill) {
            elem.showDetail = oldElem.showDetail
            Object.assign(oldElem, elem)
          }
        })
      })
    }
  }

  async function RequestValidation(element, byCertificate = false) {
    if (!element.rating) {
      Gems.Telegram(MESSAGES.ERROR.RATE_SKILL, 'tele-not-allowed')
      return
    }

    element.waiting_validation = true

    const response = await KNOLIA.CallBackEnd("post", "control-rating-skills", {
      elem: element,
      type: "request-validation",
      with_certification: byCertificate
    })

    if (!response.data?.sended_to_validator) {
      element.waiting_validation = false
      Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
    } else {
      Gems.Telegram(MESSAGES.SUCCESS.SENT, 'tele-success')
    }

    if (response.error) 
      GetRatingSkills()
  }

  function CheckForTooltip(ev, index, element) {
    const target = ev.target
    const tooltip = element.is_op_skill ? tooltipSkillOp.value[index] : tooltipKnowledge.value[index]

    Gems.Tooltip(target, tooltip, 'tooltip')
  }

  async function DefineRating(element) {
    const response = await KNOLIA.CallBackEnd("post", "control-rating-skills", {
      elem: element,
      type: "define-rating"
    })

    if (response.error) {
      GetRatingSkills()
    } else {
      element.skills_ratings_id = response.data.skills_ratings_id
    }
  }

  function SetRating(element, rating) {
    if (KNOLIA.ToBoolean(element.waiting_validation)) 
      return

    if(element.rating === rating && element.current_validation == null) 
      element.rating = null
    else 
      element.rating = rating

    DefineRating(element)
  }

  function ManageTooltip(target, element) {
    if (!element.is_op_skill)
      Gems.Tooltip(target, 'Conhecimento', 'tooltip')
  }

  function GetLastRatingTxt(element) {
    if (!element.current_rating || element.rating === element.current_rating)
      return ''

    return `[${element.current_rating}]`
  }

  function validationTooltipText(element) {
    if(element.waiting_validation)
      return `${element.waiting_validation_tooltip} [Provisório]`

    return `${element.current_validation_description}`
  }

  async function ChangeHighlight(element) {
    element.highlight = !element.highlight
    await KNOLIA.CallBackEnd('post', 'set-operations&get=highlight-rating-elem', {
        params: {
            highlight: element.highlight,
            skill_rating_id: element.skills_ratings_id
        }
    })
  }

  function SetCommentsRead(skill_rating_id, only_validators = false) { 
    rankList.value.forEach(elem => {
      if(elem.skills_ratings_id === skill_rating_id) {
        if(only_validators)
          elem.has_unread_messages_only_validators = 0
        else
          elem.has_unread_messages = 0
      }
    })
  }

  onMounted(async () => {
    if(!rankList.value.length > 0 && !router.currentRoute.value.params.validateSkills)
      await GetRatingSkills()

    window.addEventListener('resize', () => {
      isMobile.value = KNOLIA.updateIsMobile()
      isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
    })
  })

  onUpdated(async () => {
    if(!rankList.value.length > 0 && !router.currentRoute.value.params.validateSkills && !fetchingRankList.value)
      await GetRatingSkills()
  })

  return {
    rankList,
    validationList,
    isMobile,
    isLowerThanMobile,
    rankType,
    filterByJob,
    selectedDDL,
    tooltipKnowledge,
    tooltipSkillOp,
    GetRatingSkills,
    RequestValidation,
    CheckForTooltip,
    DefineRating,
    SetRating,
    ManageTooltip,
    GetLastRatingTxt,
    validationTooltipText,
    ChangeHighlight,
    SetCommentsRead,
    GetRatingSkill,
  }
}